export enum CashierSessionTypes {
    DEPOSIT=  1,
    TRANSACTIONS_HISTORY=  2,
    WITHDRAWAL=  4,
    ReverseWithdrawal = 6,
    FULL_CASHIER_CDH=  9,
    FULL_CASHIER=  8,
    QUICK_DEPOSIT=  16,
    COOLING_OFF=  18,
    VERIFY_ID=  20,
    MOBILE_VERIFY_ID=  21
}
